import { pct } from "./HealthSummary";

const hours = (h) => (h === null || h === undefined ? "N/A" : h < 48 ? `${h}h` : `${Math.round(h / 24)}d`);
const retained = (r) => (r.eligible === 0 ? "N/A" : `${pct(r.rate)} (n=${r.eligible})`);

export function CohortTable({ cohorts, minSample }) {
  if (!cohorts.length) {
    return <p className="text-sm text-slate-400 py-6 text-center" data-testid="cohort-empty">Insufficient data — no registrations yet.</p>;
  }
  return (
    <div className="overflow-x-auto -mx-2" data-testid="cohort-table">
      <table className="w-full text-sm min-w-[760px]">
        <thead>
          <tr className="text-left font-mono-plex text-[10px] uppercase tracking-[0.15em] text-slate-400 border-b border-slate-200">
            {["Cohort", "Registered", "Activation", "Time to 1st analysis", "Repeat rate", "7d retained", "30d retained", "Paid conversion"].map((h) => (
              <th key={h} className="py-2.5 px-2">{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {cohorts.map((c) => (
            <tr key={c.cohort} className="border-b border-slate-100" data-testid={`cohort-row-${c.cohort}`}>
              <td className="py-2.5 px-2 font-semibold text-[#0F172A]">
                {c.cohort}
                {c.small_sample && <span className="ml-2 font-mono-plex text-[9px] uppercase px-1.5 py-0.5 rounded bg-amber-50 text-amber-700" data-testid={`cohort-small-${c.cohort}`}>small sample</span>}
              </td>
              <td className="py-2.5 px-2">{c.registered}</td>
              <td className="py-2.5 px-2">{pct(c.activation_rate)}</td>
              <td className="py-2.5 px-2">{hours(c.median_hours_to_first_analysis)}</td>
              <td className="py-2.5 px-2">{pct(c.repeat_rate)}</td>
              <td className="py-2.5 px-2">{retained(c.retained_7d)}</td>
              <td className="py-2.5 px-2">{retained(c.retained_30d)}</td>
              <td className="py-2.5 px-2">{pct(c.paid_conversion)}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <p className="text-[11px] text-slate-400 mt-2 px-2">
        Activation = completed ≥1 analysis. Repeat = 2+ completed among activated. Retained = any activity on/after day 7 or 30, among accounts old enough (n). Cohorts under {minSample} accounts are flagged; N/A means no eligible data.
      </p>
    </div>
  );
}
